import React, { useState } from "react";
import './coinflip_style.css'
import SolLogo from './solana-sol-logo.png';
import DustLogo from './DUST.jpg'
import Coin from "../Coin";
import BetValue from "../BetValue";

const CoinFlip = ()=>{
      var [onChangeValue, setOnChangeValue] = useState('SOL');
      const currencyType = (data)=>{
        setOnChangeValue(data.target.value);
      }

      // Set the date we're counting down to
var countDownDate = new Date("Aug 09, 2022  0:0:0").getTime();

// Update the count down every 1 second
var x = setInterval(function() {

  // Get todays date and time
  var now = new Date().getTime();

  // Find the distance between now and the count down date
  var distance = countDownDate - now;

  // Time calculations for days, hours, minutes and seconds
  var days = Math.floor(distance / (1000 * 60 * 60 * 24));
  var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
  var seconds = Math.floor((distance % (1000 * 60)) / 1000);

  // Display the result in the element with id="demo"
  document.getElementById("demo").innerHTML = days + " days " + hours + " hours  "
  + minutes + " mins and " + seconds + " secs!";

  // If the count down is finished, write some text 
  if (distance < 0) {
    clearInterval(x);
    document.getElementById("demo").innerHTML = "EXPIRED";
  }
}, 1000);

      return <section className="coinflip_container">
        <div className="toss">
          <h2 className="coinFlip">Flip for $SOL,<br/>$USDC & $DUST</h2>
          <Coin/>
        </div>
        <div className="toss_options">
            <form>
                <select className="CoinType" name="CoinType" onChange={currencyType} value={onChangeValue}>
                    <option value="SOL"><img src={SolLogo}/>SOL</option>
                    <option value="DUST">DUST</option>
                    <option value="USDC">USDC</option>
                </select>
                <div className="tossOptions">
                  <div className="tossOption mr-2">
                    <input type="radio" id="f-option" name="selector" className="selector-item_radio"/>
                    <label for="f-option" className="selector-item_label">Heads</label>
                  </div>
                  <div className="tossOption">
                    <input type="radio" id="f-option2" name="selector" className="selector-item_radio"/>
                    <label for="f-option2" className="selector-item_label">Tails</label>
                  </div>
                </div>
                <div>
                <div className="betVale">
                  {
                    onChangeValue === 'SOL'? <BetValue/> : null                   
                  }
                  {
                     onChangeValue === 'DUST'? <input type='number' placeholder="Enter Value" className="dustStyle" min="1" pattern="[.][0-9]+$"/> : null 
                  }
                  {
                     onChangeValue === 'USDC'? <input type='number' placeholder="Enter Value" className="dustStyle" min="1"/> : null 
                  }
                </div>
                <div class="element">
                    
                </div>
                <button type="submit" className="submitBtn" id="demo" disabled>Calculating...</button>
                </div>
            </form>
        </div>
    </section>
}

export default CoinFlip;